import React, { useContext, useEffect, useState } from "react";
import { authenticatedContext, userDataContext } from "../App";
import { postStuff } from '../helpers/auth';
import { ButtonWIcon, DropDownGeneral, TextInput, CloseButton } from './Inputs'
import { AlertsContext } from './Layout'
import Table from "./Table";
import "../css/app_user_admin.css";
import { confirmAlert } from 'react-confirm-alert';


  const App_user_admin = () => {


  const [createOpen, setCreateOpen] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);
  const addAlertBanner = useContext(AlertsContext);

  function createNewAppAcountClick() {
    setCreateOpen(true)
  }

 function closeNewCreateWindow(){
  setCreateOpen(false) 
  setUpdateTable(!updateTable)
 }

 function handleDeletePress(app_user_id){
        confirmAlert({
            title: 'Opravdu chcete smazat Uživatelský účet?',
            message: 'Tato akce se nedá vrátit',
            buttons: [
              {
                label: 'Ano',
                onClick: ()=>{deleteAdmin(app_user_id)}
              },
              {
                label: 'Ne'
              }
            ]
          });
 }

 function deleteAdmin(app_user_id){

    postStuff('app_user/delete/' + app_user_id).then((res) => {
      if (res.status === 200) {
        addAlertBanner("Uživatel smazán", "success")
        setUpdateTable(!updateTable)
      } else if (res.status === 403) {
        addAlertBanner("Nemáte dostatečné oprávnění. Potřebujete oprávnění 4. úrovně.", "warning");
      }
      else{
        addAlertBanner("Něco se pokazilo.", "danger");
      }

    })
}


  return (
    <div className="app-admin">
      <div className="heading-controls">
        <h3>Uživatelé aplikace</h3>
        <ButtonWIcon text={"Vytvořit nového uživatele"} iconSrc={"/img/svg/add.svg"} onClick={createNewAppAcountClick} />
      </div>

      <Table
        reqUrl={"app_user/all"}
        redirectOnRecordClick={false}
        updateShit={updateTable}
        headers={[
          {
            name: "Jméno",
            dataKey: "first_name",
            search: false,
            sort: false,
            type: "text",
          },
          {
            name: "Příjmení",
            dataKey: "last_name",
            search: false,
            sort: false,
            type: "text",
          },
          {
            name: "E-mail",
            dataKey: "email",
            search: false,
            sort: false,
            type: "text",
          },
          {
            name: "Úroveň oprávnění",
            dataKey: "privilege_level",
            search: false,
            sort: false,
            type: "text"
          },
          {
            name: "Akce",
            dataKey: false,
            search: false,
            sort: false,
            type: "app_user_admin"
        }
          
        ]}
        actions={{
            controls:{
              deleteSrc: "/img/svg/bin.svg",
              onDeletePress: handleDeletePress,
            }
          }}
        
        />
      {createOpen && <CreateNewAccountWindow closeItself={closeNewCreateWindow} />}
    </div>
  );
};


function CreateNewAccountWindow({ closeItself }) {

  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [priviligeLevel, setPriviligeLevel] = useState(null)
  const [errorMess, setErrorMess] = useState("")
  const [processing, setProcessing] = useState(false)

  
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);
  const addAlertBanner = useContext(AlertsContext);

  const dropDownOptions = [
    "1 - může nahlížet na informace",
    "2 - může vytvářet a editovat klienty",
    "3 - může vytvářet/editovat podporu a mazat klienty",
    "4 - administrace projektů a uživatelských účtů"
  ]
  
  function handleSubmit() {
    if(processing)
      return
    if (!/^[a-zA-Zá-žÁ-Ž]+$/.test(firstName) || !/^[a-zA-Zá-žÁ-Ž]+$/.test(lastName) || firstName.length < 2 || lastName.length < 2) {
      setErrorMess("Neplatné jméno či příjmení");
      return false;
    }
    else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email)) {
      setErrorMess("Neplatný email");
      return;
    }
    else if(priviligeLevel === null){
      setErrorMess("Vyberte oprávnění");
      return;
    }
    addAlertBanner("Vytvářím účet", "info")
    setErrorMess(null);  
    setProcessing(true)
    
    
    const body = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      privilege_level: priviligeLevel + 1 
    }

    postStuff("app_user/create/", body).then((res) => {
      if (res.status === 200) {
          addAlertBanner("Účet vytvořen", "success")
          closeItself()
      } else if (res.status == 400) {
          if (res.data.error)
              addAlertBanner(res.data.error, "danger")
          else
              addAlertBanner("Něco se pokazilo", "danger");
      }else if(res.status == 403){
        addAlertBanner("Nemáte dostatečné oprávnění", "danger");
      }
      else if (res.status === 401) {
          setAuthenticated(false);
      } else {
          console.log("error", res)
          addAlertBanner("Něco se pokazilo", "danger");
      }
    });
    setProcessing(false)

  }

  return (
    <div className='blur-container'>
      <div className="create-account-container">
        <div className="acc-controls">
          <div className="profile-controls-container">
            <CloseButton onClick={closeItself} />
          </div>
        </div>
        <div className="heading-stf">
          <h3>Nový uživatelský účet</h3>
        </div>
        <table className="acc-details">
          <tbody>
            <tr>
              <td className="profile-label">JMÉNO</td>
              <td className="profile-value">
                <TextInput value={firstName} setValue={setFirstName} />
              </td>
            </tr>
            <tr>
              <td className="profile-label">PŘÍJMENÍ</td>
              <td className="profile-value">
                <TextInput value={lastName} setValue={setLastName} />
              </td>
            </tr>
            <tr>
              <td className="profile-label">EMAIL</td>
              <td className="profile-value">
                <TextInput email value={email} setValue={setEmail} />
              </td>
            </tr>
            <tr>
              <td className="profile-label">ÚROVEŇ OPRÁVNĚNÍ</td>
              <td className="profile-value">
                <DropDownGeneral options={dropDownOptions} title={"oprávnění"}
                  selected={priviligeLevel} setSelected={setPriviligeLevel} />
              </td>
            </tr>
          </tbody>
        </table>
        {errorMess != null && <div className="error emes">{errorMess}</div>}

        <div className="acc-controls">
          <ButtonWIcon
            iconSrc={"/img/svg/save.svg"}
            onClick={handleSubmit}
            style={{ backgroundColor: "#68E965" }}
            text={"Vytvořit účet"} 
            disabled={processing}/>
        </div>
      </div>
    </div>
  )
}

export default App_user_admin;
